import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/ibm-aiops-training/ibm-aiops-training/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`📥 STEP: Login to AI Manager`}</h2>
    <img {...{
      "src": "./../images/demo/image.054.png",
      "alt": "image"
    }}></img>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`🚀 `}<u>{`Action`}</u></strong>{`
In the Demo UI, click `}<strong parentName="p">{`AI MAnager `}<inlineCode parentName="strong">{`(1)`}</inlineCode></strong></p>
    </blockquote>
    <img {...{
      "src": "./../images/demo/image.055.png",
      "alt": "image"
    }}></img>
    <p><strong parentName="p">{`📣 `}<u>{`Narration`}</u></strong></p>
    <p>{`Let’s take a closer look at the incident that has been created in CloudPak for AIOps.`}</p>
    <h2>{`📥 STEP: Open the Story`}</h2>
    <p><img parentName="p" {...{
        "src": "./../images/demo/image.056.png",
        "alt": "image"
      }}></img>{`  `}</p>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`🚀 `}<u>{`Action`}</u></strong>{`
Click the “hamburger menu” on the upper left. Click `}<strong parentName="p">{`Stories and alerts`}</strong></p>
    </blockquote>
    <img {...{
      "src": "./../images/demo/image.057.png",
      "alt": "image"
    }}></img>
    <p><strong parentName="p">{`📣 `}<u>{`Narration`}</u></strong></p>
    <p>{`We can see that the simulation has created a `}<strong parentName="p">{`Story`}</strong>{`. The `}<strong parentName="p">{`Story`}</strong>{` includes grouped information related to the incident at hand. It equates to a classic War Room that are usually put in place in case of an outage.
The `}<strong parentName="p">{`Story`}</strong>{` contains related log anomalies, topology, similar incidents, recommended actions based on past trouble tickets, relevant events, runbooks, and more.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      